import { constants } from '@bedc/constants';
import type { types } from '@bedc/types';

export const isVolumetricTotalColumn = (
	value: string
): value is types.report.volumetrics.TotalTypes =>
	constants.report.volumetrics.totals.includes(value as types.report.volumetrics.TotalTypes);

export const isVolumetricUniqueTrussTypeColumn = (
	value: string
): value is types.report.volumetrics.UniqueTrussTypes =>
	constants.report.volumetrics.uniqueTrussTypes.includes(
		value as types.report.volumetrics.UniqueTrussTypes
	);
